import { render, staticRenderFns } from "./quick-message-menu-item.vue?vue&type=template&id=5dd6ea71"
import script from "./quick-message-menu-item.vue?vue&type=script&lang=js"
export * from "./quick-message-menu-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dd6ea71')) {
      api.createRecord('5dd6ea71', component.options)
    } else {
      api.reload('5dd6ea71', component.options)
    }
    module.hot.accept("./quick-message-menu-item.vue?vue&type=template&id=5dd6ea71", function () {
      api.rerender('5dd6ea71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/quick-message/quick-message-menu-item.vue"
export default component.exports